var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_907_12101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.49 10.2649H25.28C26.38 10.2649 27.28 11.1649 27.28 12.2649V29.7149H12.49V12.2649C12.49 11.1649 13.39 10.2649 14.49 10.2649Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65991 29.7349H30.3399",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4698 23.4648H18.2898V29.7348H21.4698V23.4648Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.95 18.4048H15.77V21.5848H18.95V18.4048Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2298 18.4048H21.0498V21.5848H24.2298V18.4048Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.95 13.345H15.77V16.525H18.95V13.345Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2298 13.345H21.0498V16.525H24.2298V13.345Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_907_12101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.68,
    height: 21.47,
    fill: "white",
    transform: "translate(8.65991 9.26489)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.0a7464f224c23d895a00b6f294ec2b5e.svg";
export { ForwardRef as ReactComponent };